/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from 'react-redux'
import { clearSignUp, saveStep } from './redux/actions'
import { useTranslation } from 'react-i18next'
import Content from '../../../common/components/Content/Content'
import styled from 'styled-components'
import ContentTitle from '../../../common/components/ContentTitle/ContentTitle'
import ButtonGroup from '../../../common/components/ButtonGroup/ButtonGroup'
import Question from '../../../common/components/Question/Question'
import SignUpNameForm from './SignUpNameForm/SignUpNameForm'
import { RootState } from '../../../root.reducer'
import SignUpContactsForm from './SignUpContactsForm/SignUpContactsForm'
import { patchProfile, clearError } from '../../generalSettings/UserProfile/redux/reducer'
import { unwrapResult } from '@reduxjs/toolkit'
import { History, Location } from 'history'
import { PopUp } from 'tinybots-react-components'

const Title = styled(ContentTitle)`
  margin-top: 20px;
`

type OnboardingProps = {
  location: Location<any>,
  history: History
}

const mapStateToProps = ({ signup, eula, userProfile }: RootState) => ({
  firstName: signup.firstName,
  lastName: signup.lastName,
  phoneNumber: signup.phoneNumber,
  termsAccepted: signup.termsAccepted,
  nameStepDone: signup.nameStepDone,
  eula: eula,
  patchError: userProfile.patchError
})

const mapDispatchToProp = {
  clearError,
  clearSignUp,
  saveStep,
  patchProfile
}
const connector = connect(mapStateToProps, mapDispatchToProp)

type PropsFromRedux = ConnectedProps<typeof connector>

export const Onboarding: React.FunctionComponent<OnboardingProps & PropsFromRedux> = (props) => {
  const [activeStep, setActiveStep] = useState(0)
  const user = props.location.state.userInfo
  const firstName = user.firstName ?? ''
  const lastName = user.lastName ?? ''

  useEffect(() => {
    return () => { props.clearSignUp() }
  }, [])

  const { t } = useTranslation()

  const submitName = (values: any) => {
    props.saveStep('name', values)
    setActiveStep(1)
  }

  const submitPhone = async (values: any) => {
    props.saveStep('contacts', values)
    await props.patchProfile({
      profile: {
        firstName: props.firstName,
        lastName: props.lastName,
        phoneNumber: values.phoneNumber,
        eulaVersionId: props.eula.latestEula?.id
      }
    }).then(unwrapResult).then(() => {
      props.history.push('/')
    }).catch((err: any) => {
      console.error(`Could not patch profile: `, err)
    })
  }

  return (
    <>{
      activeStep == 0 ? <Content>
        <Title>
          {t('AC.SIGNUP.NAME.TITLE')}
        </Title>
        <div>
          <SignUpNameForm
            firstName={firstName}
            lastName={lastName}
            handleSubmit={submitName}
          />
        </div>
        <ButtonGroup>
          <Question
            text={<span>{t('AC.SIGNUP.NAME.LINK_QUESTION')}</span>}
            description={t('AC.SIGNUP.NAME.LINK_QUESTION_DESCRIPTION')}
          />
        </ButtonGroup>
      </Content> :
        <Content navBack={() => setActiveStep(0)}>
          <Title>{t('AC.SIGNUP.CONTACTS.TITLE')}</Title>
          <div>
            <SignUpContactsForm
              fixedEmail={user.username ?? ''}
              acceptedTerms={props.termsAccepted}
              email={user.username ?? ''}
              phoneNumber={props.phoneNumber ?? ''}
              handleSubmit={submitPhone}
            />
          </div>
          <ButtonGroup>
            <Question
              text={<span>{t('AC.SIGNUP.CONTACTS.LINK_QUESTION')}</span>}
              description={t('AC.SIGNUP.CONTACTS.LINK_QUESTION_DESCRIPTION')}
            />
          </ButtonGroup>
        </Content>
      }
      {props.patchError && (
        <PopUp
          type='warning'
          title={t('POPUP.ERROR.TITLE')}
          text={t('POPUP.ERROR.MESSAGE')}
          onSubmit={clearError}
          submitButton={t('POPUP.ERROR.BUTTON_SUBMIT')}
        />
      )}
    </>

  )
}

export default connect(mapStateToProps, mapDispatchToProp)(Onboarding)
